<script lang="ts" setup>
import AppConfigurator from './AppConfigurator.vue'
import AppNotificationsMenu from '~/components/layout/AppNotificationsMenu.vue'

const { hasModulesAccess } = useAuth()
const { currentOrganization: organization } = useOrganization()
const { state: dialerState, timer } = useDialer()
const { layoutConfig, toggleMenu, toggleDarkMode } = useLayout()
const { siteName } = useSite()
</script>

<template>
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button
        class="layout-menu-button layout-topbar-action"
        @click="toggleMenu"
      >
        <i class="pi pi-bars"></i>
      </button>
      <router-link to="/" class="layout-topbar-logo">
        <img
          v-if="organization && organization.logo"
          class="h-8"
          :src="organization.logo"
          :alt="siteName"
        />
        <span>{{ siteName }}</span>
      </router-link>
    </div>

    <div class="layout-topbar-actions">
      <div class="layout-config-menu">
        <Button
          v-if="
            organization &&
            hasModulesAccess(['comms', 'crm', 'manager', 'scheduling'], true)
          "
          :label="timer > 0 ? formatDuration(timer) : undefined"
          :severity="timer > 0 ? 'primary' : 'contrast'"
          :variant="timer > 0 ? undefined : 'text'"
          icon="pi pi-phone"
          rounded
          @click="dialerState.isOpen = !dialerState.isOpen"
        />

        <AppNotificationsMenu v-if="organization" :organization />
      </div>

      <button
        class="layout-topbar-menu-button layout-topbar-action"
        v-styleclass="{
          selector: '@next',
          enterFromClass: 'hidden',
          enterActiveClass: 'animate-scalein',
          leaveToClass: 'hidden',
          leaveActiveClass: 'animate-fadeout',
          hideOnOutsideClick: true,
        }"
      >
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu hidden lg:block">
        <div class="layout-topbar-menu-content">
          <button
            type="button"
            class="layout-topbar-action"
            @click="toggleDarkMode"
          >
            <i
              :class="[
                'pi',
                {
                  'pi-moon': layoutConfig.darkTheme,
                  'pi-sun': !layoutConfig.darkTheme,
                },
              ]"
            ></i>
            <span class="lg:hidden">Dark mode</span>
          </button>

          <div class="relative">
            <button
              v-styleclass="{
                selector: '@next',
                enterFromClass: 'hidden',
                enterActiveClass: 'animate-scalein',
                leaveToClass: 'hidden',
                leaveActiveClass: 'animate-fadeout',
                hideOnOutsideClick: true,
              }"
              type="button"
              class="layout-topbar-action layout-topbar-action-highlight"
            >
              <i class="pi pi-palette"></i>
              <span class="lg:hidden">Palette</span>
            </button>
            <AppConfigurator />
          </div>

          <button
            type="button"
            class="layout-topbar-action"
            @click="() => navigateTo('/account')"
          >
            <i class="pi pi-user"></i>
            <span>Profile</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
